<mat-form-field>
    <mat-label>{{field.label}}</mat-label>
    <input matInput [disabled]="_disabled" autocomplete="off" class="dynamic-input"
        (keydown.enter)="onBlur($event)" (blur)="onBlur($event)"
        [value]="field.value" [placeholder]="" [max]="field.max" [min]="field.min" [step]="field.step" type="number"/>
</mat-form-field>
